import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "message", "position", "onShowTooltip"];
import React, { cloneElement, useEffect, useRef, useState } from 'react';
import theme from '../theme.config';
import { useUniqueId } from '../../utils/hooks';
import EzPopover from '../EzPopover';
import { domProps } from '../../utils';
var tooltip = theme.css({
  position: 'relative',
  padding: '$tooltip-padding',
  maxWidth: '300px',
  boxShadow: '$sm',
  whiteSpace: 'pre-line',
  color: '$tooltip-text',
  border: '1px solid $tooltip-border',
  backgroundColor: '$tooltip-border'
});
var popper = theme.css({
  zIndex: '$tooltip-z'
});
var arrow = theme.css({
  position: 'absolute',
  pointerEvents: 'none',
  fill: '$tooltip-bg'
});
var arrowPosition = theme.css(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "[data-popper-placement^='top'] > &", {
  bottom: 5,
  svg: {
    transform: 'rotate(180deg) translate(50%, 0)'
  }
}), "[data-popper-placement^='right'] > &", {
  left: 5,
  svg: {
    transform: 'rotate(-90deg) translate(50%, 0)'
  }
}), "[data-popper-placement^='bottom'] > &", {
  top: -5,
  svg: {
    transform: 'translate(-50%, 0)'
  }
}), "[data-popper-placement^='left'] > &", {
  right: 5,
  svg: {
    transform: 'rotate(90deg) translate(-50%, 0)'
  }
}));
var reset = theme.css({
  my: 0
});
var EzTooltip = function EzTooltip(_ref) {
  var children = _ref.children,
    message = _ref.message,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'vertical' : _ref$position,
    onShowTooltip = _ref.onShowTooltip,
    rest = _objectWithoutProperties(_ref, _excluded);
  var id = useUniqueId();
  var targetRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovered = _useState2[0],
    setIsHovered = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var onMouseEnterEvent = function onMouseEnterEvent() {
    return setIsHovered(true);
  };
  var onMouseLeaveEvent = function onMouseLeaveEvent() {
    return setIsHovered(false);
  };
  var onFocusEvent = function onFocusEvent() {
    return setIsFocused(true);
  };
  var onBlurEvent = function onBlurEvent() {
    return setIsFocused(false);
  };
  var showTooltip = isHovered || isFocused;
  var child = React.Children.only(children);
  var onShowTooltipRef = useRef(onShowTooltip);
  onShowTooltipRef.current = onShowTooltip;
  useEffect(function () {
    var _onShowTooltipRef$cur;
    if (showTooltip) (_onShowTooltipRef$cur = onShowTooltipRef.current) === null || _onShowTooltipRef$cur === void 0 || _onShowTooltipRef$cur.call(onShowTooltipRef);
  }, [showTooltip, onShowTooltipRef]);
  var childProps = {
    'aria-describedby': id,
    onMouseEnter: onMouseEnterEvent,
    onMouseLeave: onMouseLeaveEvent,
    onFocus: onFocusEvent,
    onBlur: onBlurEvent,
    ref: targetRef
  };
  var props = domProps(rest, tooltip());
  return React.createElement(React.Fragment, null, cloneElement(child, childProps), showTooltip && React.createElement(EzPopover, {
    targetRef: targetRef,
    placement: position === 'horizontal' ? 'right' : 'bottom',
    showArrow: true,
    className: popper()
  }, React.createElement("div", {
    "data-popper-arrow": true,
    className: arrowPosition()
  }, React.createElement("svg", {
    width: "10",
    height: "10",
    className: arrow()
  }, React.createElement("path", {
    d: "M0 5l5-5 5 5z"
  }), React.createElement("path", {
    d: "M1.5 5L5 1.5 8.5 5z"
  }))), React.createElement("div", _extends({
    role: "tooltip",
    id: id,
    tabIndex: -1
  }, props), message && React.createElement("p", {
    className: reset()
  }, message))));
};
export default EzTooltip;